"use strict";

exports.__esModule = true;
exports.ClassificationSelector = void 0;
var _Selector = require("../../Core/Selector");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _react = _interopRequireWildcard(require("react"));
var _CommonValidators = require("../utils/CommonValidators");
var _EnrichDefinitionContext = require("../EnrichDefinitionContext");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ClassificationSelector = exports.ClassificationSelector = function ClassificationSelector(_ref) {
  var classificationName = _ref.classificationName,
    updateSelf = _ref.updateSelf,
    isRequired = _ref.isRequired,
    showText = _ref.showText;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_EnrichDefinitionContext.EnrichDefinitionContext),
    classifications = _useContext2.classifications;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.Row, null, showText && /*#__PURE__*/_react["default"].createElement("span", null, translate("EnrichEditorUI.ClassificationSelector.Classify", "Classification") + " "), /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({}, isRequired && !(0, _CommonValidators.validateSelector)(classificationName) && {
    style: Object.assign({}, true && {
      border: "solid 1px red"
    })
  }, {
    dataTestId: "EnrichEditorUI.ClassificationSelector.NameSelector",
    items: classifications,
    getKey: function getKey(classification) {
      return classification.name;
    },
    renderItemText: function renderItemText(classification) {
      return classification.name;
    },
    selected: classificationName && [classificationName],
    onSelect: function onSelect(_ref2) {
      var classification = _ref2[0];
      updateSelf(classification);
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    }
  }))));
};